import { useTranslation } from 'react-i18next'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

const CollectionSelector = ({ collections = [], recommendationValue, onChangeValue, disabled }) => {
  const { t } = useTranslation()

  if (!collections.length) {
    return <Alert type="warning">{t('Aún no hay colecciones configuradas en la tienda.')}</Alert>
  }

  return (
    <ComboBox
      label={t('Colección')}
      menuItems={collections.map(c => ({ value: c.id, label: c.name }))}
      value={recommendationValue || collections[0]?.id}
      handleChange={e => onChangeValue(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  )
}

export default CollectionSelector
